import React from 'react'

const SoftwareReportContext = React.createContext()

export default SoftwareReportContext
